import { Serializable } from "@/core/generated/api/decorators/serializable_decorator"

export interface SupplierDuplicatesGetArgsData {
  vatNumber?: string
  domain?: string
  contactEmail?: string
}

@Serializable
export class SupplierDuplicatesGetArgs {
  vatNumber: string = ""
  domain: string = ""
  contactEmail: string = ""

  constructor(data: SupplierDuplicatesGetArgsData | null = null) {
    if (data) {
      this.vatNumber = data.vatNumber ?? ""
      this.domain = data.domain ?? ""
      this.contactEmail = data.contactEmail ?? ""
    }
  }
}
